import { isCordova } from 'e-submission/utils'
import MoreInfoPhotoCard from 'e-submission/components/Card/MoreInfoPhotoCard'
import { CheckedCard, NotCheckedCard, NotCheckedWithInputCard } from 'e-submission/components/Card/DocumentCard'

const Component = ({ icon = 'camera', ...props }) => {
  const documents = props.value
  const validateFile = props.validate
  const action = isCordova && !props.isBrowseFile ? 'ถ่ายรูป' : 'แนบรูป'
  return (
    <div>
      {documents.map((documentProps, index) => (
        <MoreInfoPhotoCard
          key={index}
          icon={icon}
          action={action}
          validateFile={validateFile}
          CheckedComponent={CheckedCard}
          NotCheckedComponent={documentProps.editable ? NotCheckedWithInputCard : NotCheckedCard}
          {...documentProps}
          {...props}
        />
      ))}
    </div>
  )
}

export default (hoc) => hoc(Component)
